import { ComponentType } from "react";
import DirectiveEntryStatusCanceled from "../../../../pages/Show/components/tabs/forwardingsTab/sections/DirectiveEntry/Status/Canceled";
import DirectiveEntryStatusOnGoingDirective from "../../../../pages/Show/components/tabs/forwardingsTab/sections/DirectiveEntry/Status/OnGoingDirectiveEntry";
import DirectiveEntryStatusOnGoingEstablishmentChoice from "../../../../pages/Show/components/tabs/forwardingsTab/sections/DirectiveEntry/Status/OnGoingEstablishmentChoice";
import { MaintenanceForwardingSectionsProps, MaintenanceForwardingStatus } from "../../../../types/forwardings/maintenanceForwarding.type";

export const maintenanceeForwardingsDirectiveEntryStateStatus: Record<MaintenanceForwardingStatus, {
  component: ComponentType<MaintenanceForwardingSectionsProps> | null;
}> = {
  canceled: {
    component: DirectiveEntryStatusCanceled,
  },
  ongoing_establishment_choice: {
    component: DirectiveEntryStatusOnGoingEstablishmentChoice,
  },
  ongoing_checkin: {
    component: null,
  },
  ongoing_directive: {
    component: DirectiveEntryStatusOnGoingDirective,
  }
}
